import React, { useEffect, useState } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import useIframeComponentHook from './useIframeComponentHook';
import './styles.scss';
import Main from '../../Main/Main';
import { useMenuSidebar } from '../../../contexts/MenuSidebarContext';
import { decodeBase64UrlSafe } from '../../Utils/utils';
import { ProjetosEnum } from '../../Shared/Enums/ProjetosEnum';
import Paginacao from '../Paginacao/Paginacao';

const Iframe = ({ escopoAcesso, setEscopoAcesso }) => {
  const { idDepartamento64, idSubMenu64 } = useParams();
  const [searchParams] = useSearchParams();
  const { scrIframe, setEnviarMensagemEsteira } = useMenuSidebar();

  const {
    skeletonLoader,
    iframeRef,
    iframeKey,
    navegarTela,
    getDadosSubMenu,
    navigate,
    enviarMensagemEsteira
  } = useIframeComponentHook({
    scrIframe,
    setEscopoAcesso
  });

  const [paginacao, setPaginacao] = useState(null);
  const [srcRestaurada, setSrcRestaurada] = useState(null);

  useEffect(() => {
    setEnviarMensagemEsteira(() => enviarMensagemEsteira);

    return () => {
      setEnviarMensagemEsteira(() => () => false);
    };
  }, [enviarMensagemEsteira, setEnviarMensagemEsteira]);

  useEffect(() => {
    if (!idDepartamento64 || !idSubMenu64) {
      navigate('/home');
      return;
    }

    const ambiente = searchParams.get('ambiente');
    const idDepartamento = parseInt(decodeBase64UrlSafe(idDepartamento64));
    const idSubMenu = decodeBase64UrlSafe(idSubMenu64);

    const carregarSubMenu = async () => {
      const subMenu = await getDadosSubMenu(idDepartamento, idSubMenu);

      if (!subMenu?.id) {
        navigate('/home');
        return;
      }

      setPaginacao(subMenu);

      // Abertura de análise em nova aba: o hub-ui envia a rota profunda da
      // proposta e o shell monta a URL autenticada (/auth) do próprio hub-ui,
      // mantendo os menus da plataforma em volta do iframe.
      const rotaIframe = searchParams.get('rotaIframe');

      if (rotaIframe) {
        window.history.replaceState({}, '', window.location.pathname);
        navegarTela(subMenu.menuId, decodeURIComponent(rotaIframe), subMenu.projeto, idDepartamento);
        return;
      }

      const storageKey = `iframe-route:${idDepartamento64}:${idSubMenu64}`;
      const rotaSalva = sessionStorage.getItem(storageKey);

      if (rotaSalva) {
        setSrcRestaurada(rotaSalva);
        return;
      }

      // Obtem CODTITULO e CODOPERACAO dos searchParams
      const codTitulo = searchParams.get('CODTITULO') || '';
      const codOperacao = searchParams.get('CODOPERACAO') || '';
      const navegarTelaIframe = searchParams.get('navegarTela') || '';

      const separador = subMenu.rota?.includes('?') ? '&' : '?';
      let queryString = '';

      if (ambiente === 'plataforma') {
        const codContaCobranca = searchParams.get('CODCONTACOBRANCA');
        const tipoRemessa = searchParams.get('TIPOREMESSA');

        queryString = `${separador}ambiente=plataforma&CODCONTACOBRANCA=${codContaCobranca}&TIPOREMESSA=${tipoRemessa}`;
      }

      if (codTitulo) {
        queryString += `${queryString ? '&' : separador}CODTITULO=${codTitulo}`;
      }

      if (codOperacao) {
        queryString += `${queryString ? '&' : separador}CODOPERACAO=${codOperacao}`;
      }

      if (navegarTelaIframe) {
        queryString = searchParams.toString();
        queryString = queryString ? `&${queryString}` : '';
        window.history.replaceState({}, '', window.location.pathname);
      }

      navegarTela(
        subMenu.menuId,
        subMenu.rota,
        subMenu.projeto,
        idDepartamento,
        parseInt(subMenu.projeto) === parseInt(ProjetosEnum.ISEVEN)
          ? `${queryString ? '&' : separador}submenu=${subMenu.id}${queryString}`
          : queryString // MODULUS também recebe QueryStrings
      );
    };

    carregarSubMenu().catch(console.error);
  }, [idDepartamento64, idSubMenu64]);

  return (
    <Main
      title="Dashboard"
      className="tela-iframe"
      escopoAcesso={escopoAcesso}
      setEscopoAcesso={setEscopoAcesso}
    >
      {(srcRestaurada || scrIframe) && (
        <iframe
          key={iframeKey}
          id="iframe-component"
          className={`iframe-component ${skeletonLoader ? 'hidden' : ''}`}
          title="Responsive Iframe"
          allow="clipboard-read; clipboard-write"
          ref={iframeRef}
          src={srcRestaurada || scrIframe}
        />
      )}

      {skeletonLoader && (
        <Stack className="skeleton" spacing={1}>
          {[...Array(4)].map((_, index) => (
            <React.Fragment key={index}>
              <Skeleton variant="text" width={index === 0 ? '20%' : '100%'} height={50} />
              <Skeleton variant="rectangular" width={index === 0 ? '20%' : '100%'} height={50} />
            </React.Fragment>
          ))}
        </Stack>
      )}
      <Paginacao paginacao={paginacao} />
    </Main>
  );
};

export default Iframe;
